<template>
    <v-row class="mx-0 h-100 bg-white flex-nowrap">
        <v-col xl="9" md="8" cols="12" class="h-100 d-flex flex-column overflow-y-auto">
            <div class="d-flex justify-center justify-sm-space-between flex-column flex-sm-row pt-2 ga-2 flex-shrink-0">
                <div class="ps-2 text-center text-sm-start">
                    <p class="mb-1 font-weight-bold">{{ ticket.title }}</p>
                    <p class="text-small mb-0">شناسه تیکت:{{ ticket.identifier }}</p>
                </div>
                <div class="d-flex align-center">
                    <v-btn-group class="mx-auto mx-sm-0" divided color="secondary" v-if="$auth.user.employee || ticket.can_share || ticket.can_transfer || ticket.can_pend || ticket.can_close">
                        <v-btn v-if="$auth.user.employee" v-tooltip="'اطلاعات تیکت'" @click="drawer = !drawer" class="px-5 d-inline-block d-md-none" size="small" icon="icon-info"></v-btn>
                        <v-btn v-if="$auth.user.employee" v-tooltip="'پایش تیکت'" @click="toggleWatched" class="px-5" size="small" :icon="watched ? 'icon-bell-ring' : 'icon-bell'"></v-btn>
                        <v-btn v-if="ticket.can_share" v-tooltip="'اشتراک‌ گذاری تیکت'" @click="$refs.ticketShares.shareDialog = true" class="px-5" size="small" icon="icon-at"></v-btn>
                        <v-btn v-if="ticket.can_transfer" v-tooltip="'انتقال تیکت'" @click="transferDialog = true" class="px-5" size="small" icon="icon-transfer"></v-btn>
                        <v-btn v-if="ticket.can_pend && ticket.ticket_status !== 1" v-tooltip="'تغییر وضعیت به در حال انجام'" @click="pendingConfirm({ticket_status: 1}, false)" class="px-5" size="small" icon="icon-pendding"></v-btn>
                        <v-btn v-if="ticket.can_close" v-tooltip="'تغییر وضعیت به بسته شده'" @click="closeConfirm({ticket_status: 4}, false)" class="px-5" size="small" icon="icon-closeticket"></v-btn>
                    </v-btn-group>
                    <v-btn v-if="!ticket.recipient_id && $auth.user.employee && ticket.to_department && $auth.user.from_departments.find(x => x.id == ticket.to_department.id)" @click="assignToMe" class="ms-5 d-none d-md-block" color="secondary" variant="outlined">
                        <v-icon icon="icon-user-add" class="me-2"></v-icon><span class="text-small font-weight-medium">اختصاص تیکت به من</span>
                    </v-btn>
                    <v-btn v-else :disabled="!ticket.can_reply" @click="showTextEditor = !showTextEditor" class="ms-5 d-none d-md-block" color="secondary" variant="outlined">
                        <v-icon icon="icon-replay" class="me-2"></v-icon><span class="text-small font-weight-medium">ثبت پاسخ</span>
                    </v-btn>
                </div>
            </div>
            <div class="rounded bg-primary pa-5 mt-4 d-flex align-center justify-space-between flex-shrink-0" v-if="ticket.can_satisfaction && $system.license.features.satisfaction_ticket">
                <v-icon class="me-2" color="#FFA62B" size="20">chat_bubble</v-icon>
                <p class="text-white text-small font-weight-medium">میزان رضایتمندی خود از روند کلی پاسخگویی به این تیکت را اعلام نمایید</p>
                <v-spacer></v-spacer>
                <v-rating
                    dir="ltr"
                    empty-icon="star_outline"
                    full-icon="star"
                    hover
                    length="5"
                    size="25"
                    active-color="#FFA62B"
                    v-model="rate"
                    color="#FFA62B"
                    @update:modelValue="sendTicket({satisfaction:rate},false)"
                ></v-rating>
            </div>
            <p v-if="!ticket.recipient_id && $auth.user.employee" class="py-2 mt-1 text-center d-block d-md-none flex-shrink-0 rounded font-weight-medium" style="font-size: 0.7rem; background-color: #ffeedd; color: #ff9f43">این تیکت به هیچ کارشناسی اختصاص داده نشده است</p>
            <div class="my-4 ps-2 overflow-y-auto text-break">
                <v-timeline align="start" :key="ticketsContent.length">
                    <v-timeline-item v-for="item in ticketsContent" width="100%">
                        <template #icon>
                            <v-avatar v-if="item.system" image="@/assets/img/systemReply.png" size="50" class="helpical-shadow"></v-avatar>
                            <v-avatar v-else-if="item.userProfileImg" :image="item.userProfileImg" size="50" class="helpical-shadow"></v-avatar>
                            <v-avatar v-else image="@/assets/img/noUser.png" size="50" class="helpical-shadow"></v-avatar>
                        </template>
                        <div
                            :style="
                                item.system
                                    ? {backgroundColor:contentStyles[item.system].backgroundColor,borderColor:contentStyles[item.system].border}
                                    : item.private ? {backgroundColor:contentStyles.NORMAL.backgroundColor,borderColor:contentStyles.NORMAL.border}
                                    : item.owner ? {backgroundColor:contentStyles.OWNER.backgroundColor,borderColor:contentStyles.OWNER.border}
                                    : {backgroundColor:contentStyles.NORMAL.backgroundColor,borderColor:contentStyles.NORMAL.border}"
                            class="rounded border"
                        >
                            <div class="pa-3">
                                <div class="d-flex align-center mb-2">
                                    <v-icon v-if="!item.system && item.private" class="me-2" color="primary" icon="lock"></v-icon>
                                    <div>
                                        <p v-if="!item.system" class="text-grey-darken-4 mb-1 test-start font-weight-bold text-small">{{ item.name }} <span class="text-small text-grey-darken-2 font-weight-medium">{{ !item.owner && !item.employee ? '(مشتری)' : '' }}</span></p>
                                        <p class="test-start text-small">{{item.date}}{{ !item.system ? ` | ${item.ticket_status}` : '' }}</p>
                                    </div>
                                    <v-spacer></v-spacer>
                                    <v-btn size="small" icon="icon-trash" color="error" variant="outlined" @click="deleteTicketContent(item.id)" class="bg-white mx-1" v-if="$auth.user.full_admin && ticketsContent.length > 1"></v-btn>
                                    <v-btn size="small" icon="icon-dislike" :color="item.satisfaction == 0 ? 'error' : 'secondary'" variant="outlined" :class="item.satisfaction == 0 ? 'active': ''" @click="changeSatisfaction(item.id,0)" class="bg-white mx-1" v-if="$system.license.features.satisfaction_reply && item.can_satisfaction"></v-btn>
                                    <v-btn size="small" icon="icon-like" :color="item.satisfaction == 1 ? 'success' : 'secondary'" variant="outlined" :class="item.satisfaction == 1 ? 'active': ''" @click="changeSatisfaction(item.id,1)" class="bg-white mx-1" v-if="$system.license.features.satisfaction_reply && item.can_satisfaction"></v-btn>
                                    <v-menu v-if="item.attachments.length" :close-on-content-click="false" style="box-shadow: unset !important;">
                                        <template #activator="{ props }">
                                            <v-badge :content="item.attachments.length">
                                                <v-btn size="small" v-bind="props" class="mx-1 bg-white" color="secondary" variant="outlined" icon="icon-attachticket"></v-btn>
                                            </v-badge>
                                        </template>
                                        <v-list>
                                            <v-list-item @click="downloadAttachment([attachment])" link v-for="(attachment,index) in item.attachments" :key="index">
                                                <v-list-item-title>
                                                    <v-icon class="me-1" color="secondary" size="18">file_download</v-icon>
                                                    <p class="text-small mb-0 text-grey-darken-1 d-inline-block">دانلود فایل الحاقی {{index + 1}}</p>
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="downloadAttachment(item.attachments)" link v-if="item.attachments.length > 1">
                                                <v-list-item-title>
                                                    <v-icon class="me-1" color="secondary" size="18">view_module</v-icon>
                                                    <p class="text-small mb-0 text-grey-darken-1 d-inline-block">دانلود همه</p>
                                                </v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </div>
                                <div :style="{color: contentStyles[item.system ? item.system : 'NORMAL'].color}" class="pe-2 text-small" v-sanitize="item.content"></div>
                            </div>
                        </div>
                    </v-timeline-item>
                </v-timeline>
            </div>
            <v-spacer></v-spacer>
            <v-expand-transition>
                <div class="flex-grow-0 flex-shrink-0" v-show="showTextEditor">
                    <ckeditor
                        ref="ticketTexteditor"
                        v-model="content"
                    ></ckeditor>
                    <div class="d-flex flex-wrap ga-3 align-center bg-blue-grey-lighten-5 border border-t-0 rounded-b pa-1">
                        <div class="d-flex flex-wrap align-center">
                            <v-btn-group class="mx-1" divided variant="flat" color="success">
                                <v-menu v-if="$auth.user.employee">
                                    <template #activator="{ props }">
                                        <v-btn v-bind="props" icon="arrow_drop_up"></v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item v-if="ticket.can_close" @click="closeConfirm({content: content,ticket_status:4})" link>
                                            <v-list-item-title>ارسال و تغییر وضعیت به بسته شده</v-list-item-title>
                                        </v-list-item>
                                        <v-list-item v-if="ticket.can_pend" @click="pendingConfirm({content: content,ticket_status:1})" link>
                                            <v-list-item-title>ارسال و تغییر وضعیت به در حال انجام</v-list-item-title>
                                        </v-list-item>
                                        <v-list-item @click="sendTicket({content: content, private: true})" link>
                                            <v-list-item-title>ارسال به صورت محرمانه</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                                <v-btn @click="sendTicket({ content: content })">
                                    <v-icon class="me-1" size="15">send</v-icon><span class="text-small">ارسال</span>
                                </v-btn>
                            </v-btn-group>
                            <v-btn v-if="!$auth.user.employee && ticket.can_close" @click="closeConfirm({content: content,ticket_status:4})" class="mx-1" color="success" variant="text">
                                <span class="text-small">ارسال و بستن</span>
                            </v-btn>
                            <v-btn @click="showTextEditor = !showTextEditor" color="error" variant="text">
                                <span class="text-small">انصراف</span>
                            </v-btn>
                        </div>
                        <v-spacer></v-spacer>
                        <div class="d-flex flex-wrap align-center">
                            <v-btn v-tooltip="'متن‌های آماده'" size="small" class="mx-1" v-if="$system.license.features.ticket_canned_message && $auth.user.employee" color="primary" @click="ticketTemplateDrawer = true" icon="icon-templateticket" variant="text"></v-btn>
                            <v-btn v-tooltip="'پایگاه دانش'" size="small" class="mx-1" v-if="$auth.user.employee && $system.license.features.kb_core && $system.systemSettings.knowledge_base_status" icon="icon-kb" variant="text" color="primary" @click="$refs.ticketKnowledgebase.dialog = true"></v-btn>
                            <v-btn v-tooltip="'درج امضاء'" size="small" class="mx-1" icon="icon-signature" variant="text" color="primary" v-if="$auth.user.employee" @click="signatureDrawer = true"></v-btn>
                            <v-badge :model-value="$refs.files && !!$refs.files.getFiles()?.length" :content="$refs.files ? $refs.files.getFiles().length : 0" location="top right">
                                <v-btn size="small" class="mx-1" icon variant="text" color="primary" v-tooltip="'فایل‌ پیوست'">
                                    <v-icon @click="attachmentDialog = true" color="primary">icon-attachticket</v-icon>
                                </v-btn>
                            </v-badge>
                        </div>
                    </div>
                </div>
            </v-expand-transition>
        </v-col>
        <v-divider vertical class="my-5"></v-divider>
        <v-col xl="3" md="4" class="h-100 overflow-y-auto d-none d-md-block">
            <p v-if="!ticket.recipient_id && $auth.user.employee" class="py-2 mb-3 text-center rounded font-weight-medium" style="font-size: 0.7rem; background-color: #ffeedd; color: #ff9f43">این تیکت به هیچ کارشناسی اختصاص داده نشده است</p>
            <Teleport defer to="#ticket-sidebar" :disabled="$vuetify.display.mdAndUp">
                <v-expansion-panels static v-model="panel">
                    <v-expansion-panel v-if="ticket">
                        <v-expansion-panel-title height="40" color="blue-grey-lighten-5">
                            <p class="font-weight-medium">
                                <v-icon class="me-2" color="secondary" icon="icon-infoticket" size="17"></v-icon>
                                <span class="text-small">اطلاعات تیکت</span>
                            </p>
                        </v-expansion-panel-title>
                        <v-expansion-panel-text>
                            <p class="text-small mt-3 mb-1 font-weight-medium">وضعیت تیکت:</p>
                            <p class="text-small d-table ms-auto">{{ $system.ticketStatuses.find(x => x.id == ticket.ticket_status)?.name }}</p>
                            <p class="text-small mt-3 mb-1 font-weight-medium" v-if="ticket.to_department">دپارتمان گیرنده تیکت:</p>
                            <p class="text-small d-table ms-auto" v-if="ticket.to_department">{{ ticket.to_department.name }}</p>
                            <p class="text-small mt-3 mb-1 font-weight-medium">دسته‌بندی تیکت:</p>
                            <p class="text-small d-table ms-auto">{{ ticket.ticket_category ? ticket.ticket_category.name : "سایر" }}</p>
                            <p class="text-small mt-3 mb-1 font-weight-medium" v-if="ticket.service">محصول/سرویس:</p>
                            <p class="text-small d-table ms-auto" v-if="ticket.service">{{ ticket.service.name }}</p>
                            <p class="text-small mt-3 mb-1 font-weight-medium" v-if="ticket.can_satisfaction && ticket.satisfaction">میزان رضایتمندی:</p>
                            <p class="text-small d-table ms-auto" v-if="ticket.can_satisfaction && ticket.satisfaction">{{ $system.satisfactionList.find(x => x.id == ticket.satisfaction).name }}</p>
                            <p class="text-small mt-3 mb-1 font-weight-medium" v-if="ticket.can_share">اشتراک گذاری تیکت:</p>
                            <v-btn @click="$refs.ticketShares.shareDialog = true" class="ms-auto d-block" color="grey-lighten-3" variant="flat" v-if="ticket.can_share">
                                <v-icon class="me-1" size="16">open_in_new</v-icon>
                                {{ ticket.shares.length }} نفر
                            </v-btn>
                            <p class="text-small mt-3 mb-1 font-weight-medium">درجه اهمیت تیکت:</p>
                            <div :class="`bg-${$system.importances.find(x => x.id == ticket.importance)?.color}`" class="rounded ms-auto d-table px-3 mb-6 py-1 text-center text-white font-weight-medium text-small">{{ $system.importances.find(x => x.id == ticket.importance)?.name }}</div>
                            <div class="text-center mt-3" v-if="$system.license.features.custom_field && ticket.custom_fields && ticket.custom_fields.length">
                                <v-btn @click="$refs.customFieldShowRef.drawer = true" >
                                    <v-icon class="me-1" color="grey-darken-2" size="20">description</v-icon>
                                    <p class="text-grey-darken-2 font-weight-bold text-small">اطلاعات تکمیلی تیکت</p>
                                </v-btn>
                            </div>
                            <div class="text-center" v-if="$auth.user.full_admin">
                                <v-btn @click="deleteTicket" class="text-small" color="red" variant="text">
                                    <v-icon size="15" class="pe-1">icon-trash</v-icon> حذف تیکت
                                </v-btn>
                            </div>
                        </v-expansion-panel-text>
                    </v-expansion-panel>
                    <v-expansion-panel v-if="customerInformation">
                        <v-expansion-panel-title height="40" color="blue-grey-lighten-5">
                            <p class="font-weight-medium">
                                <v-icon class="me-2" color="secondary" icon="icon-userticket" size="17"></v-icon>
                                <span class="text-small">اطلاعات مشتری</span>
                            </p>
                        </v-expansion-panel-title>
                        <v-expansion-panel-text>
                            <v-btn color="primary" class="mt-2" block @click="$refs.customerCallDialog.dialog = true" v-if="$refs.customerCallDialog && $refs.customerCallDialog.hasNumber()">
                                <v-icon size="16" class="me-1" style="transform: rotate(270deg);">call</v-icon>تماس با مشتری
                            </v-btn>
                            <v-btn tag="a" class="mt-2 py-6" block color="secondary" variant="tonal" target="_blank" :href="$rbac.can('manage customers') ? `/customers/${customerInformation.id}` : ''">
                                <v-img v-if="customerInformation.userProfileImg" :src="customerInformation.userProfileImg" class="rounded" height="32" width="32"></v-img>
                                <v-img v-else src="@/assets/img/noUser.png" class="rounded" height="32" width="32"></v-img>
                                <div class="text-small ms-1 me-3 text-grey-darken-3 text-truncate">{{ $text.substrTable(customerInformation?.name, 19) }}</div>
                                <v-icon  size="17" color="secondary" v-if="$rbac.can('manage customers')">open_in_new</v-icon>
                            </v-btn>
                            <p class="text-small mt-3 mb-1 font-weight-medium" v-if="customerInformation.email">ایمیل:</p>
                            <p class="text-small d-table ms-auto" v-if="customerInformation.email">{{ customerInformation.email }}</p>
                            <p class="text-small mt-3 mb-1 font-weight-medium" v-if="customerInformation.mobile">شماره موبایل:</p>
                            <p class="text-small d-table ms-auto" v-if="customerInformation.mobile">{{ customerInformation.mobile }}</p>
                            <p class="text-small mt-3 mb-1 font-weight-medium" v-if="customerInformation.customer_information.customer_level">سطح مشتری:</p>
                            <p class="text-small d-table ms-auto" v-if="customerInformation.customer_information.customer_level">{{ customerInformation.customer_information.customer_level.name }}</p>
                            <p class="text-small mt-3 mb-1 font-weight-medium" v-if="customerInformation.customer_information && customerInformation.customer_information.organization">سازمان:</p>
                            <p class="text-small d-table ms-auto" v-if="customerInformation.customer_information && customerInformation.customer_information.organization">{{ customerInformation.customer_information.organization.name }}{{ customerInformation.customer_information.supervisor ? ' (سرپرست سازمان)' : '' }}</p>
                            <div class="text-center" v-if="$auth.user.employee && $system.license.features.customer_event && $rbac.can('view customer information')">
                                <v-btn @click="customerHistoryDrawer = true" variant="text" color="secondary">
                                    <v-icon size="20">restore</v-icon><span class="ms-1 text-small">تاریخچه رویدادهای مشتری</span>
                                </v-btn>
                            </div>
                            <div class="text-center" v-if="$auth.user.employee && $rbac.can('view customer information')">
                                <v-btn @click="customerInformationDrawer = true" color="secondary" variant="text">
                                    <v-icon size="15" class="pe-1">icon-info</v-icon><span class="text-small">جزئیات بیشتر</span>
                                </v-btn>
                            </div>
                        </v-expansion-panel-text>
                    </v-expansion-panel>
                    <v-expansion-panel v-if="(ticket.first_reply_duetime || ticket.resolve_duetime) && $auth.user.employee">
                        <v-expansion-panel-title height="40" color="blue-grey-lighten-5">
                            <p class="font-weight-medium">
                                <v-icon class="me-2" color="secondary" icon="icon-slaticket" size="17"></v-icon>
                                <span class="text-small">توافقنامه سطح خدمت (SLA)</span>
                            </p>
                        </v-expansion-panel-title>
                        <v-expansion-panel-text>
                            <div class="d-flex justify-space-between align-center w-100">
                                <p class="text-small font-weight-medium">اولین پاسخ تیکت</p>
                                <div :style="{background: ticket.first_reply_duetime == 'failed' ? '#db3a31' : ticket.first_reply_duetime == 'passed' ? '#34c38f' : '#2877DC',width:'80px'}" class="rounded text-center text-white py-2 px-6" :class="ticket.first_reply_duetime == 'failed' || ticket.first_reply_duetime == 'passed' ? 'text-small' : ''">{{ ticket.first_reply_duetime == 'failed' ? 'ناموفق' : ticket.first_reply_duetime == 'passed' ? 'موفق' : ticket.first_reply_duetime }}</div>
                            </div>
                            <div class="mt-3 d-flex justify-space-between align-center w-100">
                                <p class="text-small font-weight-medium">بسته شدن تیکت</p>
                                <div :style="{background: ticket.first_reply_duetime == 'failed' ? '#db3a31' : ticket.first_reply_duetime == 'passed' ? '#34c38f' : '#2877DC',width:'80px'}" class="rounded text-center text-white py-2 px-6" :class="ticket.first_reply_duetime == 'failed' || ticket.first_reply_duetime == 'passed' ? 'text-small' : ''">{{ ticket.first_reply_duetime == 'failed' ? 'ناموفق' : ticket.first_reply_duetime == 'passed' ? 'موفق' : ticket.first_reply_duetime }}</div>
                            </div>
                        </v-expansion-panel-text>
                    </v-expansion-panel>
                    <v-expansion-panel v-if="customerInformation && $rbac.can('view customer information')">
                        <v-expansion-panel-title height="40" color="blue-grey-lighten-5">
                            <p class="font-weight-medium">
                                <v-icon class="me-2" color="secondary" icon="icon-label" size="17"></v-icon>
                                <span class="text-small">برچسب مشتری</span>
                            </p>
                        </v-expansion-panel-title>
                        <v-expansion-panel-text>
                            <tag-input class="pt-5" v-model="customerTags" type="customer" :id="customerInformation.id"></tag-input>
                        </v-expansion-panel-text>
                    </v-expansion-panel>
                    <v-expansion-panel v-if="$auth.user.employee && ticket">
                        <v-expansion-panel-title height="40" color="blue-grey-lighten-5">
                            <p class="font-weight-medium">
                                <v-icon class="me-2" color="secondary" icon="icon-label" size="17"></v-icon>
                                <span class="text-small">برچسب تیکت</span>
                            </p>
                        </v-expansion-panel-title>
                        <v-expansion-panel-text>
                            <tag-input class="pt-5" v-model="ticketTags" type="ticket" :id="$route.params.id"></tag-input>
                        </v-expansion-panel-text>
                    </v-expansion-panel>
                </v-expansion-panels>
            </Teleport>
        </v-col>
    </v-row>
    <v-navigation-drawer location="left" color="#f1f1f1" order="2" temporary width="400" v-model="drawer">
        <v-card tile color="transparent">
            <v-toolbar color="white">
                <v-btn @click="drawer = false" icon>
                    <v-icon color="primary" size="23">close</v-icon>
                </v-btn>
                <v-toolbar-title class="text-primary">اطلاعات تیکت</v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <div class="px-2">
                <div class="mt-3" id="ticket-sidebar"></div>
            </div>
        </v-card>
    </v-navigation-drawer>
    <v-fade-transition>
        <v-fab
            app
            color="primary"
            location="bottom left"
            size="50"
            icon="icon-reply"
            class="d-block d-md-none"
            v-if="!showTextEditor && ticket.can_reply"
            @click="showTextEditor = true"
        ></v-fab>
    </v-fade-transition>
    <v-dialog persistent v-model="transferDialog" width="500">
        <v-card tile>
            <v-toolbar color="white">
                <v-toolbar-title class="text-primary">انتقال تیکت</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn @click="transferDialog = false" icon>
                    <v-icon color="primary" size="23">close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-form @submit.prevent="$refs.transferForm.isValid && sendTicket({transfer_department:transfer_department,transfer_user: transfer_user,content: transfer_content,private: transfer_private},false)" ref="transferForm" class="px-6 mt-2">
                <p class="text-grey-darken-2 text-small mb-3">دقت فرمایید که پس از انتقال تیکت، دسترسی آخرین کاربر سازمانی به فرد جدید منتقل خواهد شد و تیکت از دسترس کاربر سازمانی قبلی خارج می‌گردد.</p>
                <v-select
                    :rules="$validation('required')"
                    :items="departmentList"
                    @update:modelValue="departmentChange"
                    item-title="name"
                    item-value="id"
                    label="* انتخاب دپارتمان"
                    no-data-text="موردی پیدا نشد!"
                    v-model="transfer_department"
                ></v-select>
                <v-select
                    :rules="$validation('required')"
                    :disabled="users.length > 0 ? false : true"
                    :items="users"
                    :loading="transfer_department && !users.length ? true : false"
                    :item-title="item => item.name + (item.supervisor ? ' (سرپرست)' : '')"
                    item-value="id"
                    label="* انتخاب کاربر"
                    no-data-text="موردی پیدا نشد!"
                    v-model="transfer_user"
                ></v-select>
                <v-textarea
                    label="متن پیام"
                    no-resize
                    rows="3"
                    v-model="transfer_content"
                ></v-textarea>
                <switch-input v-model="transfer_private" label="وضعیت متن پیام" false-label="عمومی" true-label="محرمانه" tooltip="پیام‌های محرمانه توسط مشتریان قابل مشاهده نمی‌باشند."></switch-input>
                <v-card-actions class="pb-4 px-5">
                    <v-btn type="submit" variant="flat" color="success" >تایید</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="transferDialog = false" color="error" variant="text">بستن</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
    <v-dialog persistent v-model="ticketTemplateDrawer" width="700">
        <v-card tile>
            <v-toolbar color="white">
                <v-toolbar-title class="text-primary">متن‌های آماده</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn @click="ticketTemplateDrawer = false" icon>
                    <v-icon color="primary" size="23">close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <div class="px-6 mt-5 text-grey-darken-2 position-relative" style="min-height: 350px;max-height: 400px;overflow-y: auto;scrollbar-width: thin;">
                <v-text-field
                    append-inner-icon="search"
                    class="mb-4 bg-white"
                    label="جستجو"
                    style="position: sticky; top: 0; z-index: 300"
                    v-model="ticketTemplateSearchbox"
                ></v-text-field>
                <v-row align="center" class="mx-0 rounded mb-2" justify="space-between" style="background-color: #f8f8f8" v-for="(item, index) in filteredTicketTemplateList" :key="index">
                    <v-col @click="item.showBody = !item.showBody">
                        <p class="mb-0 text-grey-darken-2 text-meta user-select-none cursor-pointer">
                            <v-icon color="grey-darken-2" size="24">{{item.showBody? "arrow_drop_up": "arrow_drop_down"}}</v-icon>{{ item.name }}
                        </p>
                    </v-col>
                    <v-col class cols="auto">
                        <v-btn @click="setTicketTemplate(item.body)" class="text-secondary" color="#C8DFFE">
                            <v-icon color="secondary" size="18">add</v-icon><p class="mb-0 ms-1 text-small">انتخاب</p>
                        </v-btn>
                    </v-col>
                    <v-col class="bg-grey-lighten-2 rounded pa-0" cols="12" style="height: 1px" v-if="item.showBody"></v-col>
                    <v-expand-transition>
                        <v-col class="pa-0" cols="12" v-if="item.showBody">
                            <p class="text-grey-darken-2 text-small px-3 pt-2" v-sanitize="item.body" ></p>
                        </v-col>
                    </v-expand-transition>
                </v-row>
            </div>
        </v-card>
    </v-dialog>
    <v-dialog persistent v-model="attachmentDialog" width="500" eager>
        <v-card tile>
            <v-toolbar color="white">
                <v-toolbar-title class="text-primary">آپلود فایل‌های پیوست</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn @click="attachmentDialog = false" icon>
                    <v-icon color="primary" size="23">close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <div class="px-6 py-4 text-grey-darken-2">
                <p class="text-small text-grey-darken-3 mb-0">فرمت های مجاز فایل های پیوست: {{$system.systemSettings.attachments_allowed_types.map(x => x.toUpperCase()).join(', ')}}</p>
                <p class="text-small text-grey-darken-3 mb-0 mt-n1">حداکثر حجم تمام فایل های پیوست: {{$system.systemSettings.attachments_maximum_size}}</p>
                <p class="text-small text-grey-darken-3 mb-0 mt-n1">حداکثر تعداد فایل پیوست: 5 مورد</p>
                <file-input
                    class="mt-3"
                    :style="{backgroundColor: '#e7e7e7', borderRadius: '4px'}"
                    :text="`<p class='text-meta font-weight-bold text-center mb-0 py-7'>آپلود فایل‌های پیوست</p>`"
                    :types="$system.systemSettings.attachments_allowed_types"
                    :mimeTypes="$system.systemSettings.attachments_allowed_types.map(x => $system.mimeTypes[x]).flat()"
                    :size="parseInt($system.systemSettings.attachments_maximum_size) * ($system.systemSettings.attachments_maximum_size.indexOf('MB') != -1 ? 1048576 : 1024)"
                    :maxFiles="5"
                    type="file"
                    ref="files"
                ></file-input>
            </div>
            <v-card-actions class="pb-4 mx-2">
                <v-btn @click="attachmentDialog = false" block variant="flat" color="success" >بستن و ادامه</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog persistent v-model="signatureDrawer" width="700">
        <v-card tile>
            <v-toolbar color="white">
                <v-toolbar-title class="text-primary">امضا ها</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn @click="signatureDrawer = false" icon>
                    <v-icon color="primary" size="23">close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <div class="px-6 mt-5 text-grey-darken-2 position-relative" style="min-height: 350px;max-height: 400px;overflow-y: auto;scrollbar-width: thin;">
                <v-row align="center" class="mx-0 rounded my-1" justify="space-between" style="background-color: #f8f8f8" v-for="(item, index) in signatureList" :key="index">
                    <v-col @click="item.showBody = !item.showBody">
                        <p class="mb-0 text-grey-darken-2 text-meta user-select-none cursor-pointer">
                            <v-icon color="grey-darken-2" size="24">{{item.showBody? "arrow_drop_up": "arrow_drop_down"}}</v-icon>
                            {{ item.name }}
                        </p>
                    </v-col>
                    <v-col class cols="auto">
                        <v-btn @click="setTicketTemplate(item.body)" class="text-secondary" color="#C8DFFE">
                            <v-icon color="secondary" size="18">add</v-icon><p class="mb-0 ms-1 text-small">انتخاب</p>
                        </v-btn>
                    </v-col>
                    <v-col class="bg-grey-lighten-2 rounded pa-0" cols="12" style="height: 1px" v-if="item.showBody"></v-col>
                    <v-expand-transition>
                        <v-col class="pa-0" cols="12" v-if="item.showBody">
                            <p class="text-grey-darken-2 text-small px-3 pt-2" v-sanitize="item.body" ></p>
                        </v-col>
                    </v-expand-transition>
                </v-row>
            </div>
        </v-card>
    </v-dialog>
    <ticketShare
        @sendTicket="sendTicket"
        ref="ticketShares"
    ></ticketShare>
    <custom-fields-show ref="customFieldShowRef" :customFields="ticket.custom_fields"></custom-fields-show>
    <v-navigation-drawer location="left" color="#f1f1f1" temporary v-model="customerInformationDrawer" v-if="customerInformation" width="400">
        <v-card tile color="transparent">
            <v-toolbar color="white">
                <v-btn @click="customerInformationDrawer = false" icon>
                    <v-icon color="primary" size="23">close</v-icon>
                </v-btn>
                <v-toolbar-title class="text-primary">اطلاعات مشتری</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-divider></v-divider>
            <div class="px-2 mt-3">
                <ticket-customer-information :user="customerInformation"></ticket-customer-information>
            </div>
        </v-card>
    </v-navigation-drawer>
    <v-navigation-drawer location="left" color="#f1f1f1" temporary v-model="customerHistoryDrawer" width="400">
        <v-card tile color="transparent">
            <v-toolbar color="white">
                <v-btn @click="customerHistoryDrawer = false" icon>
                    <v-icon color="primary" size="23">close</v-icon>
                </v-btn>
                <v-toolbar-title class="text-primary">تاریخچه رویدادهای مشتری</v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <div class="px-2">
                <customer-event-sidebar :user="customerInformation" :key="customerInformation"></customer-event-sidebar>
            </div>
        </v-card>
    </v-navigation-drawer>
    <customer-call-dialog ref="customerCallDialog"></customer-call-dialog>
    <ticket-knowledgebase @paste="setTicketTemplate" ref="ticketKnowledgebase"></ticket-knowledgebase>
</template>
<script>
export default {
    title: "اطلاعات تیکت",
    data() {
        return {
            panel: 0,
            rate: 0,
            ticketTemplateDrawer: false,
            customerInformationDrawer: false,
            customerHistoryDrawer: false,
            transferDialog: false,
            ticketDetailMenu: false,
            showTextEditor: false,
            customerInformation: null,
            customer: false,
            attachmentDialog: false,
            signatureDrawer: false,
            signatureList: [],
            drawer: false,
            //*ticketTemplate
            ticketTemplateList: [],
            ticketTemplateSearchbox: null,
            //!
            //*transferDialog
            transfer_department: null,
            transfer_user: null,
            transfer_content: '',
            transfer_private: false,
            //!
            //*contentStyle
            contentStyles: {
                MEETING: {
                    backgroundColor: "#f0f5fa",
                    border: "#0d3b6626",
                    color: "#606060",
                },
                TRANSFER: {
                    backgroundColor: "#DEEFFF",
                    border: "#458AE1",
                    color: "#458AE1",
                },
                CLOSE: {
                    backgroundColor: "#DEEFFF",
                    border: "#458AE1",
                    color: "#458AE1",
                },
                SHARE: {
                    backgroundColor: "#DEEFFF",
                    border: "#458AE1",
                    color: "#458AE1",
                },
                PENDING: {
                    backgroundColor: "#DEEFFF",
                    border: "#458AE1",
                    color: "#458AE1",
                },
                NORMAL: {
                    backgroundColor: "#f0f5fa",
                    border: "#0d3b6626",
                    color: "#606060",
                },
                OWNER: {
                    backgroundColor: "#ffffff",
                    border: "#0d3b6626",
                    color: "#606060",
                },
            },
            watched: false,
            //!
            //*tags
            ticketTags: [],
            customerTags: [],
            //
            content: '',
            intervals: [],
            ticket_id: false,
            departmentList: [],
            ticketsContent: [],
            ticket: false,
            users: [],
        };
    },
    computed: {
        filteredTicketTemplateList() {
            if (this.ticketTemplateSearchbox) {
                var items = this.ticketTemplateList.filter((x) => {
                        if (x.name.includes(this.ticketTemplateSearchbox)) return { ...x };
                    }).filter(Boolean);
                return items;
            } else return this.ticketTemplateList;
        },
    },
    methods: {
        setTicketTemplate(content) {
            this.$refs.ticketTexteditor.insertContent(content)
            this.ticketTemplateDrawer = false;
            this.signatureDrawer = false;
            this.$refs.ticketKnowledgebase.dialog = false;
        },
        async downloadAttachment(attachments) {
            this.$loading.start();
            await Promise.all(attachments.map(x => this.$downloadAttachment(x.id).then(res => {
                let name = x.name.split('/').at(-1);
                this.$fileDownload(res.data, decodeURIComponent(name.substring(0, name.indexOf('?'))));
            })));
            this.$loading.finish();
        },
        toggleWatched() {
            this.$ticketUpdate(this.ticket_id, {
                watched: !this.watched,
                _method: 'put'
            }).then((res) => {
                if (res && res.status == "UPDATED") {
                    this.$toast.success(res.message);
                    this.watched = !this.watched;
                }
            });
        },
        assignToMe(){
            if (!this.ticket.recipient_id) {
                this.sendTicket({assign_to_me: true}, false)
            }
        },
        departmentChange(value) {
            this.transfer_user = null;
            this.users = this.departmentList.find((x) => x.id === value).users;
            if (this.$auth.user.full_admin)
                this.users = this.users.filter((x) => x.branch_id == this.ticket.branch_id || x.branch_id == -1);
            let ticketUsers = [this.ticket.owner_id];
            if (this.ticket.recipient_id)
                ticketUsers.push(this.ticket.recipient_id);
            this.users = this.users.filter(x => !ticketUsers.includes(x.id));
        },
        closeConfirm(params, haveContent = true){
            this.$confirm(`<p class="mb-0 font-weight-medium mt-2">آیا از انجام این عملیات اطمینان دارید؟</p><p class="text-small mb-0 mt-2">در صورت تایید، وضعیت تیکت بسته خواهد شد و رسیدگی به آن خاتمه خواهد یافت.</p>`).then(res=>{
                if(res)
                    this.sendTicket(params, haveContent)
            });
        },
        pendingConfirm(params, haveContent = true){
            this.$confirm(`<p class="mb-0 font-weight-medium mt-2">آیا از انجام این عملیات اطمینان دارید؟</p><p class="text-small mb-0 mt-2">در صورت تایید، وضعیت تیکت به در حال انجام تغییر پیدا خواهد کرد.</p>`).then(res=>{
                if(res)
                    this.sendTicket(params, haveContent)
            });
        },
        deleteTicket(){
            if (this.$auth.user.full_admin) {
                this.$confirm(`<p class="mb-0 font-weight-medium mt-2">آیا از انجام این عملیات اطمینان دارید؟</p><p class="text-small mb-0 mt-2">در صورت تایید، این تیکت حذف خواهد شد و پس از این در دسترس هیچ فردی نخواهد بود.</p>`).then(async res=>{
                    if(res) {
                        this.$loading.start();
                        await this.$ticketDelete(this.ticket_id).then(res => {
                            if(res && res.status == 'DELETED') {
                                this.$toast.success(res.message);
                                return this.$router.push({path: '/tickets'})
                            }
                        }).finally(()=>{this.$loading.finish()});
                    }
                });
            }
        },
        startSetInterval(item, name) {
            if (item != "failed" && item != "passed") {
                let time = item.split(":");
                var self = this;
                this.intervals[name] = setInterval(function () {
                    if (time[1] == 0 && time[0] == 0) {
                        clearInterval(this.intervals[name]);
                    } else {
                        if (time[1] != 0) time[1] -= 1;
                        else {
                            time[1] = 59;
                            time[0] -= 1;
                        }
                    }
                    self.$data.ticket[name] = `${time[0]}:${time[1] < 10 ? "0" : null}${time[1]}`;
                }, 60000);
            }
        },
        deleteTicketContent(id) {
            if (this.$auth.user.full_admin) {
                this.$confirm(`<p class="mb-0 font-weight-medium mt-2">آیا از انجام این عملیات اطمینان دارید؟</p><p class="text-small mb-0 mt-2">در صورت تایید، این پاسخ حذف خواهد شد و پس از این در دسترس هیچ فردی نخواهد بود.</p>`).then(async res=>{
                    if(res) {
                        this.$loading.start();
                        await this.$deleteTicketContent(id).then(async res => {
                            if(res && res.status == 'DELETED') {
                                this.$toast.success(res.message);
                                await this.getTikcetList();
                            }
                        }).finally(()=>{this.$loading.finish()});
                    }
                });
            }
        },
        changeSatisfaction(id, name) {
            this.$satisfaction({
                ticket_content_id: id,
                satisfaction: name,
            }).then((res) => {
                if (res && res.status == "UPDATED") {
                    this.$toast.success("نظر شما ثبت گردید");
                    this.ticketsContent.find((x) => x.id == id).satisfaction = name;
                }
            });
        },
        sendTicket(params, haveContent = true) {
            if (haveContent && !params.content.replace(/<[^>]*>?/gm, "")) {
                this.$toast.error("متن تیکت اجباری است");
            } else {
                this.$loading.start();
                let backToArchive = false;
                if (params.transfer_department) {
                    backToArchive = true;
                    if(!params.content)
                        delete params.content;
                }
                if (params.shares && params.shares.length && !params.content) {
                    params.shares.forEach((el) => {
                        delete el.name;
                    });
                }
                if (this.$refs.files) {
                    let attachments = this.$refs.files.getValidFiles();
                    if(attachments.length)
                        params.attachments = attachments.map(x => x.file);
                }
                params._method = 'put';
                this.$ticketUpdate(this.ticket_id, params.attachments ? this.$object.toFormData(params) : params).then(
                    async (res) => {
                        if (res && res.status == "UPDATED") {
                            this.$toast.success(res.message);
                            if(backToArchive)
                                return this.$router.push({path: '/tickets'})
                            if (params.content) this.content = '';
                            if (params.satisfaction && !this.$auth.user.canSendTicket) this.$auth.fetchUser(true);
                            if(this.$auth.user.employee) {
                                this.$refs.ticketShares.shareDialog = false;
                                this.transferDialog = false;
                            }
                            if(this.$refs.files)
                                this.$refs.files.removeAllFiles();
                            await this.getTikcetList();
                            this.showTextEditor = false;
                        }
                    }
                ).finally(()=>{this.$loading.finish()});
            }
        },
        async getTikcetList() {
            await this.$ticketGet(this.ticket_id)
                .then(async (res) => {
                    if (res && res.status == "OK") {
                        let ticket = { ...res.data };
                        let contents = [];
                        for (const el of ticket.contents) {
                            let content = {
                                date: this.$moment(el.created_at).format('dddd | HH:mm:ss | jYYYY/jMM/jDD'),
                                name: el.user ? el.user.name : null,
                                user_id: el.user ? el.user.id : null,
                                employee: el.user ? el.user.employee : false,
                                satisfaction: el.satisfaction,
                                owner: el.owner,
                                content: el.body,
                                id: el.id,
                                system: el.system ? el.system : false,
                                private: el.private,
                                attachments: el.attachments,
                                can_satisfaction: el.can_satisfaction,
                                userProfileImg: el.user?.profile_picture_name,
                                ticket_status: this.$system.ticketStatuses.find((x) => x.id == el.ticket_status).name
                            };
                            contents.push(content);
                        };
                        this.ticketsContent = contents;
                        delete ticket.contents;
                        this.rate = Object.hasOwn(ticket, 'satisfaction') ? ticket.satisfaction : 0;
                        if (this.$auth.user.employee) {
                            this.ticketTags = ticket.tags;
                            this.watched = ticket.watched;
                            delete ticket.watched;
                            delete ticket.tags;
                            this.signatureList = this.$auth.user.full_admin || this.$auth.user.branch_admin
                            ? [{
                                    'name': this.$auth.user.full_admin ? 'مدیر ارشد' : 'سرپرست شعبه',
                                    'body': this.$auth.user.manager_information && Object.hasOwn(this.$auth.user.manager_information, 'signature') ? this.$auth.user.manager_information.signature : null,
                                    'showBody': false
                                }]
                            : this.$auth.user.positions.map(x => {
                                return {
                                    'name': this.$system.departments.find((el) => el.id == x.department_id).name,
                                    'body': Object.hasOwn(x, 'signature') ? x.signature : null,
                                    'showBody': false
                                }
                            });
                            if (ticket.sla) {
                                ticket.first_reply_duetime = ticket.sla.first_reply == "failed" || ticket.sla.first_reply == "passed" ? ticket.sla.first_reply : Math.floor(ticket.sla.first_reply / 3600) + ":" + Math.floor((ticket.sla.first_reply % 3600) / 60);
                                ticket.resolve_duetime = ticket.sla.resolve == "failed" || ticket.sla.resolve == "passed" ? ticket.sla.resolve : Math.floor(ticket.sla.resolve / 3600) + ":" + Math.floor((ticket.sla.resolve % 3600) / 60);
                            }
                            if(this.$refs.ticketShares)
                                this.$refs.ticketShares.getTicketShares(ticket);
                            if((ticket.owner && !ticket.owner.employee) || (ticket.recipient && !ticket.recipient.employee)) {
                                // check customer only be owner or not!
                                this.customerInformation = ticket.owner && !ticket.owner.employee ? ticket.owner : ticket.recipient;
                                this.customerInformation.userProfileImg = this.customerInformation?.profile_picture_name;
                                if (this.$rbac.can('view customer information')) {
                                    this.customerTags = this.customerInformation.tags;
                                    delete this.customerInformation.tags;
                                    this.$refs.customerCallDialog.calculateNumbers(this.customerInformation);
                                }
                            }
                        }
                        this.ticket = ticket;
                    }
                })
                .then(() => {
                    if (this.ticket.first_reply_duetime)
                        this.startSetInterval(this.ticket.first_reply_duetime, "first_reply_duetime");
                    if (this.ticket.resolve_duetime)
                        this.startSetInterval(this.ticket.resolve_duetime, "resolve_duetime");
                });
        },
    },
    mounted() {
        this.$nextTick(async () => {
            this.ticket_id = this.$route.params.id;
            this.$loading.start();
            await this.getTikcetList();
            if (this.$auth.user.employee) {
                this.departmentList = this.$auth.user.to_departments.filter(x =>
                    x.id != this.$system.customers_department.id &&
                    x.users.some(y =>
                        ![this.ticket.owner_id, this.ticket.recipient_id].includes(y.id) &&
                        (!this.$auth.user.full_admin || y.branch_id == this.ticket.branch_id || y.branch_id == -1)
                    )
                );
                if(this.$system.license.features.ticket_canned_message)
                    this.ticketTemplateList = this.$system.ticketTemplates.map((x) => {if(this.ticket.from_department.id == x.department_id || this.ticket.to_department.id == x.department_id) return { ...x, showBody: false };}).filter(Boolean);
            }
            this.$socket.channel('ticket.' + this.ticket_id).listen('ticketChangeEvent', () => {
                if(this.$route.path == `/tickets/${this.ticket_id}`) {
                    this.getTikcetList()
                } else {
                    this.$socket.leave('ticket.' + this.ticket_id);
                }
            });
            this.$loading.finish();
        });
    },
    watch: {
        attachmentDialog() {
            setTimeout(() => {
                this.attachmentDialog ? this.$refs.files.activePasteEvent() : this.$refs.files.deactivePasteEvent();
            }, 100);
        },
        showTextEditor() {
            if (this.showTextEditor) {
                this.$nextTick(() => {
                    this.$refs.ticketTexteditor.focus();
                });
            }
        }
    },
    beforeUnmount() {
        clearInterval(this.intervals['first_reply_duetime']);
        clearInterval(this.intervals['resolve_duetime']);
        this.$socket.leave('ticket.' + this.ticket_id);
    },
};
</script>
